// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"StreamsLimitModal-module__modal-content__3zMxj"};